var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 20C14.1211 19.9976 16.1545 19.154 17.6543 17.6542C19.1541 16.1544 19.9977 14.121 20.0001 12V1C20.0001 0.734784 19.8947 0.48043 19.7072 0.292893C19.5196 0.105357 19.2653 0 19.0001 0C18.7348 0 18.4805 0.105357 18.293 0.292893C18.1054 0.48043 18.0001 0.734784 18.0001 1V12C18.0001 13.5913 17.3679 15.1174 16.2427 16.2426C15.1175 17.3679 13.5914 18 12.0001 18C10.4088 18 8.88264 17.3679 7.75742 16.2426C6.6322 15.1174 6.00006 13.5913 6.00006 12V1C6.00006 0.734784 5.8947 0.48043 5.70717 0.292893C5.51963 0.105357 5.26528 0 5.00006 0C4.73484 0 4.48049 0.105357 4.29295 0.292893C4.10542 0.48043 4.00006 0.734784 4.00006 1V12C4.00244 14.121 4.84606 16.1544 6.34584 17.6542C7.84561 19.154 9.87906 19.9976 12.0001 20Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21.9994H1C0.734784 21.9994 0.48043 22.1047 0.292893 22.2923C0.105357 22.4798 0 22.7342 0 22.9994C0 23.2646 0.105357 23.5189 0.292893 23.7065C0.48043 23.894 0.734784 23.9994 1 23.9994H23C23.2652 23.9994 23.5196 23.894 23.7071 23.7065C23.8946 23.5189 24 23.2646 24 22.9994C24 22.7342 23.8946 22.4798 23.7071 22.2923C23.5196 22.1047 23.2652 21.9994 23 21.9994Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.e941c470d454526d856c9191cee5f59a.svg";
export { ForwardRef as ReactComponent };